import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { hi } from "./hi";
import { th } from "./th";
import { ar } from "./ar";

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "हिं" },
  { code: "th", label: "ไทย", short: "ไทย" },
  { code: "ar", label: "العربية", short: "ع" },
];
export const RTL = new Set(["ar"]);
const VALID = new Set(LANGS.map((l) => l.code));

export const readLang = () => {
  const q = (window.location.search.match(/[?&]lang=([a-z]{2})/) || [])[1];
  const cookie = (document.cookie.match(/(?:^|;\s*)ar_lang=([a-z]{2})/) || [])[1];
  let stored = null;
  try { stored = localStorage.getItem("ar_lang"); } catch (_) {}
  return [q, cookie, stored].find((c) => VALID.has(c)) || "en";
};

export const saveLang = (code) => {
  if (!VALID.has(code)) return;
  document.cookie = `ar_lang=${code}; path=/; max-age=31536000; SameSite=Lax`;
  try { localStorage.setItem("ar_lang", code); } catch (_) {}
};

export const applyLangToDocument = (code) => {
  const root = document.documentElement;
  root.lang = code;
  root.dir = RTL.has(code) ? "rtl" : "ltr";
  LANGS.forEach((l) => root.classList.remove("applang-" + l.code));
  root.classList.add("applang-" + code);
};

const initial = readLang();

i18n.use(initReactI18next).init({
  resources: { hi: { translation: hi }, th: { translation: th }, ar: { translation: ar } },
  lng: initial,
  fallbackLng: "en",
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

saveLang(initial);
applyLangToDocument(initial);

let _sheenEl = null;
const triggerSheen = (reduce) => {
  if (reduce) return;
  if (!_sheenEl) { _sheenEl = document.createElement("div"); _sheenEl.className = "lang-sheen"; document.body.appendChild(_sheenEl); }
  _sheenEl.classList.remove("run");
  void _sheenEl.offsetWidth;
  _sheenEl.classList.add("run");
};

export const changeLang = (code) => {
  if (!VALID.has(code) || code === i18n.language) return;
  const run = () => { saveLang(code); applyLangToDocument(code); i18n.changeLanguage(code); };
  const reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  triggerSheen(reduce);
  if (!reduce && document.startViewTransition) document.startViewTransition(run);
  else run();
};

// Keep landing and app in sync: the landing fires ar:lang / writes the cookie.
const syncFromCookie = () => {
  const c = (document.cookie.match(/(?:^|;\s*)ar_lang=([a-z]{2})/) || [])[1];
  if (VALID.has(c) && c !== i18n.language) changeLang(c);
};
window.addEventListener("ar:lang", syncFromCookie);
window.addEventListener("storage", (e) => { if (e.key === "ar_lang") syncFromCookie(); });
window.addEventListener("focus", syncFromCookie);

// Pre-warm the non-Latin fonts right after first render so a switch never waits.
if (typeof document !== "undefined" && document.fonts) {
  const warm = () => ["Noto Sans Devanagari", "Noto Sans Thai", "Noto Sans Arabic"].forEach((f) => { try { document.fonts.load(`400 1em "${f}"`); document.fonts.load(`600 1em "${f}"`); } catch (_) {} });
  if ("requestIdleCallback" in window) requestIdleCallback(warm); else setTimeout(warm, 1200);
}

export default i18n;
